module.exports = __webpack_public_path__ + "img/busca-tematica-insecto.9dc4e0b0.jpg";